import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import "../components/text_display/Text_display.css";
import { businessSchemaDE, businessSchemaEN } from "../schema";

const PrivacyNotice = () => {
  const { i18n } = useTranslation();
  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  const handleLinkKeyDown = (e, href) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      window.location.href = href;
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {i18n.language === "en"
            ? "Imprint - Violin Maker Jacobi"
            : "Impressum - Geigenbau Jacobi"}
        </title>
      </Helmet>
      <script type="application/ld+json">
        {JSON.stringify(currentSchema)}
      </script>
      <main className="privacy-notice-container" role="main">
        <section role="region" aria-labelledby="imprint-heading">
          <h1
            id="imprint-heading"
            className="privacy-header focus-highlight"
            tabIndex={0}
          >
            Impressum
          </h1>

          <section role="region" aria-labelledby="provider-info-heading">
            <h2
              id="provider-info-heading"
              className="privacy-subheader focus-highlight"
              tabIndex={0}
            >
              Anbieterkennung gem. §5 TMG
            </h2>
            <address className="privacy-text focus-highlight" tabIndex={0}>
              Geigenbaumeister Andreas Jacobi
              <br />
              Bischof-Blum-Platz 9<br />
              65366 Geisenheim /Rheingau -Germany-
              <br />
              Tel.: 0049-(0)6722-971982
              <br />
              E-Mail: kontakt@geigenbau-jacobi.de
              <br />
              USt-IdNr.: DE812653016
              <br />
              Handelsregister: Amtsgericht Rüdesheim
              <br />
              Bei der Handwerkskammer Wiesbaden eingetragener Betrieb
            </address>
          </section>

          <nav role="navigation" aria-label="Rechtliche Dokumente">
            <a
              href={
                i18n.language === "en"
                  ? "/en/privacy_notice"
                  : "/privacy_notice"
              }
              className="focus-highlight"
              tabIndex={0}
              aria-label="Datenschutzerklärung aufrufen"
              onKeyDown={(e) => handleLinkKeyDown(e, "/privacy_notice")}
            >
              Datenschutzerklärung
            </a>
            <br />
            <a
              href={i18n.language === "en" ? "/en/disclaimer" : "/disclaimer"}
              className="focus-highlight"
              tabIndex={0}
              aria-label="Haftungsausschluss aufrufen"
              onKeyDown={(e) => handleLinkKeyDown(e, "/disclaimer")}
            >
              Haftungsausschluss
            </a>
          </nav>

          <section
            role="region"
            aria-labelledby="content-responsibility-heading"
          >
            <h3 id="content-responsibility-heading" className="sr-only">
              Inhaltliche Verantwortung
            </h3>
            <p className="privacy-text focus-highlight" tabIndex={0}>
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:
              <br />
              Andreas Jacobi (Adresse wie oben angegeben)
            </p>
          </section>

          <section role="region" aria-labelledby="dispute-resolution-heading">
            <h3 id="dispute-resolution-heading" className="sr-only">
              Streitbeilegung
            </h3>
            <div className="privacy-text">
              <p className="focus-highlight" tabIndex={0}>
                EU-Streitschlichtung
                <br />
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:
                <a
                  href="https://consumer-redress.ec.europa.eu/index_de"
                  className="focus-highlight"
                  tabIndex={0}
                  aria-label="EU Online-Streitbeilegung Plattform (öffnet in neuem Fenster)"
                  target="_blank"
                  rel="noopener noreferrer"
                  onKeyDown={(e) =>
                    handleLinkKeyDown(
                      e,
                      "https://consumer-redress.ec.europa.eu/index_de"
                    )
                  }
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
            </div>

            <div className="privacy-text">
              <p className="focus-highlight" tabIndex={0}>
                Verbraucherstreitbeilegung
                <br/>
                Unsere E-Mail-Adresse finden Sie oben
                im Impressum. Wir sind nicht verpflichtet und nicht bereit, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </section>
        </section>
      </main>
    </>
  );
};

export default PrivacyNotice;
